export const JOURNAL_SORT_POPULAR = 'popular';

export const JOURNAL_SORT_OPTIONS: { id: number; label: string; value: string }[] = [
  { id: 1, label: 'Новизне', value: 'default' },
  { id: 2, label: 'Популярности', value: JOURNAL_SORT_POPULAR },
];

export const SEARCH_MIN_LENGTH = 3;
export const SEARCH_DEBOUNCE_DELAY = 500;

export const JOURNAL_PRIORITY_CARDS_COUNT = 4;
